<template>
  <div id="main-wrapper"  :class="{ 'no-style': registerAndLoginPage }">
    <div ref="scrollContainer" class="global-scrollbar">
      <div class="app-content">
        <div
          class="layout-container flex justify-center"
          :class="{
            column: navPos === 'top' || navPos === 'bottom',
            boxed: boxed,
            'footer-above': footer === 'above',
            'content-only': !navPos,
          }"
        >
          <vertical-nav
            v-if="isLogged && navPos === 'left'"
            :position="navPos"
            :collapse-nav="collapseNav"
            :open-sidebar.sync="openSidebar"
            @collapse-nav-toggle="collapseNav = !collapseNav"
            @push-page="closeSidebar"
          />

          <div class="container flex column box grow">
            <div class="header fixed-top" v-if="isLogged && toolbar === 'top' && navPos">
              <Toolbar
                @toggle-sidebar="openSidebar = !openSidebar"
                :menu-burger="navPos"
              />
            </div>
            <horizontal-nav
              v-if="isLogged && navPos === 'top'"
              :position="navPos"
              @push-page="closeSidebar"
            />
            <div class="header fixed-top" v-if="isLogged && toolbar === 'bottom' && navPos">
              <Toolbar
                @toggle-sidebar="openSidebar = !openSidebar"
                :menu-burger="navPos"
              />
            </div>

            <div
              class="main box grow flex"
              :class="{ 'middle-content': !registerAndLoginPage }"
            >
              <span
                class="main-out-border--top-left"
                v-if="roundedCorners"
              ></span>
              <span
                class="main-out-border--top-right"
                v-if="roundedCorners"
              ></span>
              <span
                class="main-out-border--bottom-left"
                v-if="roundedCorners"
              ></span>
              <span
                class="main-out-border--bottom-right"
                v-if="roundedCorners"
              ></span>
              <transition :name="viewAnimation" mode="out-in">
                <router-view class="view box grow" />
              </transition>
            </div>

            <horizontal-nav
              v-if="isLogged && navPos === 'bottom'"
              :position="navPos"
              @push-page="closeSidebar"
              style="margin-bottom: 0"
            />
            <Footer v-if="isLogged && footer === 'below'" :position="footer" />
          </div>

          <vertical-nav
            v-if="isLogged && navPos === 'right'"
            :position="navPos"
            :collapse-nav="collapseNav"
            :open-sidebar.sync="openSidebar"
            @collapse-nav-toggle="collapseNav = !collapseNav"
            @push-page="closeSidebar"
          />
        </div>
      </div>
    </div>
    <expiredPasswordModal />
    <newPasswordModal />
    <AcceptCookiesAlert />
  </div>
</template>

<script>
import { userInfoRequest } from "@/api/apiRequests/myProfileApi.js";
import { instance } from "@/api/apiInstances/apiInstance.js";

import { detect } from "detect-browser";
const browser = detect();
const activityEvents = ["mousemove", "keypress", "click", "touchstart"];

import HorizontalNav from "@/core/horizontal-nav.vue";
import VerticalNav from "@/core/vertical-nav.vue";
import Toolbar from "@/core/toolbar.vue";
import Footer from "@/core/footer.vue";

import AcceptCookiesAlert from "@/components/AcceptCookiesAlert.vue";
import newPasswordModal from "@/components/Profile/newPasswordModal.vue";
import expiredPasswordModal from "@/components/Profile/expiredPasswordModal.vue";

import {
  _shouldShowPopup,
  logout,
} from "@/globalFunctions/utilityFunctions.js";

export default {
  name: "App",
  components: {
    HorizontalNav,
    VerticalNav,
    Toolbar,
    Footer,
    AcceptCookiesAlert,
    newPasswordModal,
    expiredPasswordModal,
  },
  data() {
    return {
      collapseNav: false,
      openSidebar: false,
      innerWidth: 0,
      inactivityTimer: null,
    };
  },
  computed: {
    navPos() {
      if (
        this.innerWidth <= 1240 &&
        (this.$store.getters.navPos === "top" ||
          this.$store.getters.navPos === "bottom")
      ) {
        return "left";
      }
      return this.$store.getters.navPos;
    },

    toolbar() {
      return this.$store.getters.toolbar;
    },
    footer() {
      return this.$store.getters.footer;
    },
    boxed() {
      return this.$store.getters.boxed;
    },
    roundedCorners() {
      return this.$store.getters.roundedCorners;
    },
    viewAnimation() {
      return this.$store.getters.viewAnimation || "none";
    },
    isLogged() {
      return this.$store.getters.isLogged;
    },
    roleId() {
      return this.$store.getters.user.roleId;
    },
   registerAndLoginPage() {
    return this.$route.name === "register_page" || this.$route.name === "verify_email" || this.$route.name === "login";
  }
  },
  methods: {
    resizeOpenNav() {
      this.innerWidth = window.innerWidth;
      if (window.innerWidth <= 1240) {
        this.collapseNav = false;
      }
    },
    closeSidebar() {
      this.openSidebar = false;
    },
    logout,
    resetLogoutTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.logout();
      }, 15 * 60 * 1000); // 15 minutes
    },
  },

  created() {
    if (this.$store.getters.isLogged) {
      userInfoRequest(instance)
        .then((response) => {
          // console.log("App->userInfoRequest response:", response);
          const user = response.data.user;
          this.$store.commit("setUser", user);
        })
        .catch((err) => {
          // console.log(err);
        });
    }

    // this store action has a isLogged check in itself
    if (this.roleId !== 2) {
      this.$store.dispatch("fetchMyCurrentPresence");
    }
    // Show the cookie popup on load if not previously accepted
    //if _shouldShowPopup() == false, that means that the cookies are accepted
    if (!_shouldShowPopup()) {
      this.$store.commit("cookiesAccepted");
    }
  },
  mounted() {
    this.resizeOpenNav();
    window.addEventListener("resize", this.resizeOpenNav);

    this.resetLogoutTimer();
    // Event listeners to reset the inactivity timer
    const globalScrollbar = document.querySelector(".global-scrollbar");
    globalScrollbar?.addEventListener("scroll", this.resetLogoutTimer);
    activityEvents.forEach((event) => {
      window.addEventListener(event, this.resetLogoutTimer);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeOpenNav);

    const globalScrollbar = document.querySelector(".global-scrollbar");
    globalScrollbar?.removeEventListener("scroll", this.resetLogoutTimer);
    activityEvents.forEach((event) => {
      window.removeEventListener(event, this.resetLogoutTimer);
    });
    clearTimeout(this.inactivityTimer);
  },
};
</script>

<style lang="scss">
@import "./assets/scss/_variables";
@import "./assets/scss/_mixins";

#main-wrapper {
  background-color: $background-color;
}
#main-wrapper.no-style .main {
  padding: 0 !important;
}
#main-wrapper.no-style .main {
  padding: 0 !important;
}

.global-scrollbar {
  height: 100vh; /* Set the desired height for the scrollbar */
  overflow: auto; /* Enable scrolling within the component */
}

.middle-content {
  margin-top: 70px;
}

.layout-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: $background-color;
  color: $main-text-color !important;

  .container {
    overflow: hidden;

    .header {
      height: 60px;
      margin-bottom: 20px;
      margin-top: 10px;
      margin-left: 30px;
      margin-right: 30px;
    }

    .main {
      position: relative;
      overflow: hidden;
      padding: 0 30px;
    }

    .view {
      padding-bottom: 10px;
      padding-top: 0px;
      box-sizing: border-box;
      transition: all 0.4s cubic-bezier(0.55, 0, 0.1, 1);
      backface-visibility: hidden;
    }
    .fade-top-in-out-enter {
      opacity: 0;
      transform: translate(0, 30px);
    }
    .fade-top-in-out-leave-active {
      opacity: 0;
      transform: translate(0, 30px);
    }

    .fade-top-enter {
      opacity: 0;
      transform: translate(0, 30px);
    }
    .fade-top-leave-active {
      opacity: 0;
      transform: translate(0, -30px);
    }

    .fade-bottom-in-out-enter {
      opacity: 0;
      transform: translate(0, -30px);
    }
    .fade-bottom-in-out-leave-active {
      opacity: 0;
      transform: translate(0, -30px);
    }

    .fade-bottom-enter {
      opacity: 0;
      transform: translate(0, -30px);
    }
    .fade-bottom-leave-active {
      opacity: 0;
      transform: translate(0, 30px);
    }

    .fade-left-enter {
      opacity: 0;
      transform: translate(30px, 0);
    }
    .fade-left-leave-active {
      opacity: 0;
      transform: translate(-30px, 0);
    }

    .fade-right-enter {
      opacity: 0;
      transform: translate(-30px, 0);
    }
    .fade-right-leave-active {
      opacity: 0;
      transform: translate(30px, 0);
    }

    .fade-enter {
      opacity: 0;
    }
    .fade-leave-active {
      opacity: 0;
    }

    .main-out-border {
      &--top-left,
      &--top-right {
        background: linear-gradient($background-color, rgba(230, 235, 241, 0));
        height: 16px;
        position: absolute;
        width: 8px;
        z-index: 1;
        top: 4px;
      }
      &--bottom-left,
      &--bottom-right {
        background: linear-gradient(rgba(230, 235, 241, 0), $background-color);
        height: 16px;
        position: absolute;
        width: 8px;
        z-index: 1;
        bottom: 4px;
      }

      &--top-left,
      &--bottom-left {
        left: 42px;

        &::after {
          content: "";
          height: 5px;
          position: absolute;
          right: -4px;
          top: -4px;
          width: 12px;
          box-shadow: 8px 0px 0px 0px $background-color inset;
          border-top-left-radius: 5px;
        }
      }
      &--top-right,
      &--bottom-right {
        right: 42px;

        &::after {
          content: "";
          height: 5px;
          left: -4px;
          position: absolute;
          top: -4px;
          width: 12px;
          box-shadow: -8px 0px 0px 0px $background-color inset;
          border-top-right-radius: 5px;
        }
      }

      &--bottom-left:after {
        border-radius: 0;
        border-bottom-left-radius: 5px;
      }
      &--bottom-right:after {
        border-radius: 0;
        border-bottom-right-radius: 5px;
      }

      &--bottom-left,
      &--bottom-right {
        &::after {
          top: initial;
          bottom: -4px;
        }
      }
    }
  }

  &.boxed {
    max-width: 1300px;
    margin: 0 auto;
    box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.15),
      0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  }

  &.footer-above {
    padding-bottom: 40px;
    position: relative;
  }

  &.content-only {
    .container {
      .main-out-border--top-left,
      .main-out-border--top-right,
      .main-out-border--bottom-left,
      .main-out-border--bottom-right {
        display: none;
      }
    }
  }
}

html:not(.ie) {
  .layout-container {
    .container {
      max-width: 1920px;
    }
  }
}

@media (min-width: 1920px) {
  .layout-container:not(.boxed) {
    &.column {
      .container {
        margin: 0 auto;
      }
    }
  }
}

@media (min-width: 1241px) {
  .header {
    display: none;
  }
}

@media (max-width: 1240px) {
  .layout-container {
    .container {
      .header {
        height: 50px;
        background: #fff;
        box-shadow: 0px -20px 10px 20px rgba(0, 0, 0, 0.25);
        margin: 0;
        margin-bottom: 5px;

        .toggle-sidebar {
          box-shadow: none !important;
        }

        .search-box {
          & > .el-autocomplete {
            box-shadow: none !important;
          }
        }
      }

      .main {
        padding: 0 5px;
      }

      .view {
        max-width: 100%;
        padding: 15px;
        padding-left: 0px;
        padding-right: 0px;
      }
      .main-out-border--top-left,
      .main-out-border--top-right,
      .main-out-border--bottom-left,
      .main-out-border--bottom-right {
        display: none;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

//TABLE styles
//table search input styles
.toolbar-box .search.el-input input,
.toolbar-box .card-shadow--medium.el-select input {
  border-color: $text-color-purple;
  color: #5f6281;
  font-size: 16px;

  cursor: text;
}

.toolbar-box .search.el-input input::placeholder {
  color: $text-color-purple;
}

.el-input--mini .el-input__icon {
  line-height: 28px;
  font-size: 16px;
  color: $text-color-purple;
}

.toolbar-box.align-center.d-inline-block {
  float: right;
  margin: 10px;
  margin-right: 20px;
  width: 30%;
}

@media (max-width: 600px) {
  .toolbar-box {
    width: 94% !important;
    margin-left: 3% !important;
    margin-right: 3% !important;
    margin-top: 0 !important;
    float: none !important;
  }
}

//presence table row styles
.table-row-odd {
  background: #fafcff !important;
}
.table-row-even {
  background: rgb(238, 242, 248) !important;
}

//calendar table row styles
.calendar-table-row-odd {
  background: #fafcff !important;
  .el-table__cell {
    padding: 4px 0 !important;
  }
}
.calendar-table-row-even {
  background: rgb(238, 242, 248) !important;
  .el-table__cell {
    padding: 4px 0 !important;
  }
}

.error-message {
  color: red;
}

// Styles for terms and conditions (cookie and privacy policy)
.terms-conds {
  padding-left: 10px !important;
  padding-right: 10px !important;

  @media (max-width: 1240px) {
    & {
      margin-top: 0px;
      padding-top: 0px !important;
    }
  }

  @media (min-width: 1240px) {
    & {
      margin-top: 10px;
    }
  }

  p,
  li {
    font-size: 14px;
    font-weight: lighter;
    text-align: justify;
  }

  .dashed {
    list-style-type: "- ";
  }

  .accept {
    background-color: #1dc9b7;
    border-radius: 3px;
    width: auto;
    margin: 10px auto;
    margin-bottom: 30px;
    color: white !important;
    padding: 5px 15px;
    font-size: 16px;

    &:hover {
      background-color: #11a192;
    }

    &:active {
      background-color: #0d6b62;
    }
  }
}

// Styles for jump and size in tables
.sizes-per-page {
  margin-left: 20px;
  font-weight: lighter;
}
.el-pagination__jump {
  color: $main-text-color !important;
}
.el-pagination__sizes {
  margin-right: 10px !important;

  .el-select.el-select--mini {
    .el-input.el-input--mini.el-input--suffix {
      max-width: 70px !important;
    }
  }
}
// End of styles for jump and size in tables

header.el-drawer__header {
  color: #646c9a;
  margin-bottom: 5px;
  border-bottom: 1px solid lightgrey;
}
.no-pointer-events {
  pointer-events: none;
}
</style>

<style>
.tippy-box {
  box-shadow: 0 0 1px gray !important;
  background-color: white !important;
  border: 2px solid #ebedf2 !important;
}
.tippy-arrow {
  color: lightgrey !important;
}
.success-icon {
  font-size: 60px;
  color: rgb(0, 186, 0);
}

.el-loading-mask {
  z-index: 7;
}
</style>